// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Global native form-control theming.
 *
 * KeepTrack uses \`browser-default\` native form controls in many menus
 * (calculator, watchlist, find-sat, symbology, heatmaps, optical-sim, polar-plot,
 * the sensor chip picker, and the best-pass column toggles). Left raw, Chromium
 * paints the focus ring, the selected/checked control, and the <select> dropdown
 * with the OS blue, which clashes with the brand-red theme. This file themes them
 * globally so every menu - v13 or legacy - matches.
 *
 * What CSS can theme (handled here):
 *   - accent-color: checkbox / radio / range / progress.
 *   - select:focus: red border + outline instead of the native blue.
 *   - option:checked: the selected row in the open <select> popup.
 *
 * What CSS CANNOT theme: the *hover* highlight inside a native <select> popup is
 * drawn by the OS and is not stylable in Chromium (accent-color and option:hover
 * do not reach it). A Materialize dropdown (initMaterialSelects, which renders a
 * custom .dropdown-content list) is the only way to fully theme that popup.
 */

:root {
  accent-color: var(--color-primary);
}

select:focus {
  border-color: var(--color-primary);
  outline-color: var(--color-primary);
}

select option:checked,
select option:hover {
  background-color: var(--color-primary);
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/engine/ui/theme-form-controls.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;EAmBE;;AAEF;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;;EAEE,sCAAsC;EACtC,WAAW;AACb","sourcesContent":["/**\n * Global native form-control theming.\n *\n * KeepTrack uses `browser-default` native form controls in many menus\n * (calculator, watchlist, find-sat, symbology, heatmaps, optical-sim, polar-plot,\n * the sensor chip picker, and the best-pass column toggles). Left raw, Chromium\n * paints the focus ring, the selected/checked control, and the <select> dropdown\n * with the OS blue, which clashes with the brand-red theme. This file themes them\n * globally so every menu - v13 or legacy - matches.\n *\n * What CSS can theme (handled here):\n *   - accent-color: checkbox / radio / range / progress.\n *   - select:focus: red border + outline instead of the native blue.\n *   - option:checked: the selected row in the open <select> popup.\n *\n * What CSS CANNOT theme: the *hover* highlight inside a native <select> popup is\n * drawn by the OS and is not stylable in Chromium (accent-color and option:hover\n * do not reach it). A Materialize dropdown (initMaterialSelects, which renders a\n * custom .dropdown-content list) is the only way to fully theme that popup.\n */\n\n:root {\n  accent-color: var(--color-primary);\n}\n\nselect:focus {\n  border-color: var(--color-primary);\n  outline-color: var(--color-primary);\n}\n\nselect option:checked,\nselect option:hover {\n  background-color: var(--color-primary);\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
